



























































import { Component, Vue, Prop } from 'vue-property-decorator';
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";
import { getModule } from "vuex-module-decorators";
import { Choice } from '@/api/model/Choice';
import Choices from '@/store/modules/Choices';
import Users from '@/store/modules/Users';
import Decisions from '@/store/modules/Decisions';
import { Decision } from '@/api/model/Decision';

const workspaceOptionsModule = getModule(WorkspaceOptions);
const choicesModule = getModule(Choices);
const userModule = getModule(Users);
const decisionsModule = getModule(Decisions);
@Component({
    components: {
    },
})
export default class ChoiceVisibilityMenu extends Vue {
    @Prop({default:'', type: String})
    choiceId!: string

    private shareOptions = [{name: 'View, Edit, Delete', id: "ALL"}, {name: 'Edit', id: "EDIT"}, {name: 'View', id: "VIEW"}]
    private visibilityOptions = [{name: 'Public', id: "PUBLIC"}, {name: 'Private', id: "PRIVATE"}]
    private internalShareSettings: 'ALL' | 'EDIT' | 'VIEW' = "ALL";
    private internalVisibility = "PUBLIC";
    private show = false;
    get choice(): Choice {
        return choicesModule.choices[this.choiceId]
    }

    get selectedDecision(): Decision {
        return decisionsModule.selectedDecision
    }

    get canUserAccessPermissions(): boolean {
        let usersModule = getModule(Users)
        // console.log(this.choice)

        //If null then user can do whatever they want to their own new local choice
        if(this.choice === null) {
            return true;
        }

        //Owner of decision can always delete choices
        if(decisionsModule.selectedDecision.ownerUserId === usersModule.currentUserProfile.userId) {
            return true
        }

        //Can delete choices user is owner of
        if(this.choice.ownerUserId === usersModule.currentUserProfile.userId) {
            return true
        }

        if(decisionsModule.isAdmin) {
            return true;
        }


        //Reaching here means user is not owner of choice or decision
        return false
    }

    get ownerOfChoice(): string {
        if(this.choice === null) {
            return 'You'
        }
        
        let usersModule = getModule(Users);
        let owner = this.choice.ownerUserId
        if(owner != null && owner != undefined) {
            if(owner === usersModule.currentUserProfile.userId) {
                return 'You'
            }
            return `${decisionsModule.selectedDecisionUsers[owner]?.first} ${decisionsModule.selectedDecisionUsers[owner]?.last}` 
        } else {
            if(this.selectedDecision.ownerUserId === usersModule.currentUserProfile.userId) {
                return 'You'
            }
            return `${decisionsModule.selectedDecisionUsers[this.selectedDecision.ownerUserId]?.first} ${decisionsModule.selectedDecisionUsers[this.selectedDecision.ownerUserId]?.last}`
        }
    }

    private loadValues() {
        this.internalShareSettings = this.choice.shareSetting
        this.internalVisibility = this.choice.visibility
    }

    private cancel() {
        this.show = false;

    }

    private async save() {
        let payload = this.choice;
        payload.shareSetting = this.internalShareSettings 
        payload.visibility = this.internalVisibility
        choicesModule.updateChoice({choice: payload, refreshScoring: false})
        this.show = false;
    }
}
